@import "src/styles/common/_colors.scss";

.countLabel {
  border-left-width: 0.5px;
  padding-left: 0.5rem;
  height: 30px;
  display: flex;
  align-items: center;
  color: $description-color;
  border-left-style: solid;
  border-color: $description-color;
  font-size: 10px;
}

.showInBlue {
  color: $selected-blue;
  margin-left: 2px;
  font-style: italic;
}
.reportListContainer {
  gap: 1rem;
  padding: 0.625rem 0;
  height: 100%;
  .radioButtonGroup {
    gap: 0;
    margin-left: -0.5rem;
  }
  .multiSingleSelection {
    flex-direction: column;
  }
  .reportListWrapper {
    height: 100%;
    .reportPanel {
      height: calc(100% - 20px);
      .panelList {
        background: $gray;
        height: 90%;
        overflow-y: visible !important;
        display: flex;
        flex-direction: column;
        border: 1px solid $black;
        .panelListInner {
          height: 100%;
          position: relative;
          .reportListHeader {
            border-bottom: 1px solid $orientation-icon-color;
            display: flex;
            gap: 1rem;
            height: 30px;
            align-items: center;
            &.noBorder {
              border-bottom: none;
            }
          }
          .reportListBody {
            width: 100%;
            max-height: calc(100% - 30px);
            overflow-y: scroll;
            position: absolute;
          }
        }
        .emptyMessage {
          display: flex;
          align-items: center;
          justify-content: center;
          flex: 1;
        }
      }
      .reportActionsWrapper {
        display: flex;
        width: 100%;
        margin-top: 5px;
        align-items: center;
      }
    }
  }
  .searchHighlight {
    background-color: $text-highlight;
    color: $white;
  }
}
